import { render } from "./DeleteResourceModal.vue?vue&type=template&id=1839e2ab"
import script from "./DeleteResourceModal.vue?vue&type=script&lang=js"
export * from "./DeleteResourceModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/fran/Desarrollo/soyasi/ebim-crm/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"DeleteResourceModal.vue"]])

export default __exports__